import React from 'react';
import { observer } from 'mobx-react';
import { FullAutoRenew } from './full-auto-renew';
import { FullNoRenew } from './full-no-renew';
import { GroupAccess } from './group-access';
import { AppFactory } from '@app/app-factory';
import { PausedAccess } from './paused-access';

export const MembershipTable = observer(() => {
  const { membershipState } = AppFactory.root.userManager;

  switch (membershipState) {
    case 'trial':
      return null;

    // not currently relevant
    case 'paused':
      return <PausedAccess />;

    case 'full-auto-renew':
    case 'suspended':
      return <FullAutoRenew />;

    case 'full-no-renew':
      return <FullNoRenew />;

    case 'group-access':
      return <GroupAccess />;

    default:
      return null;
  }
});
